import { gql } from '@apollo/client'
import type { UseDocumentResult } from '@ztechapps/common.hook'
import { useDocument, useUser } from '@ztechapps/common.hook'
import type { Order } from '@ztechapps/common.contract'

export const orderGetCartQuery = gql(`
  query orderGetCart($filter: JSON) {
    orderGetCart(filter: $filter) {
      _id
      status
      items {
        _id
      }
    }
  }
`)

export const useOrderCartCount = (): { count: number; _id: string } & Pick<UseDocumentResult<Order>, 'refetch'> => {
  const { loggedIn } = useUser()

  //this should be refreshed after the mutation of isInCart
  const { document, refetch } = useDocument<Order>({
    filter: { _id: { $ne: null } },
    query: orderGetCartQuery,
    entity: 'orderGetCart',
    sort: { code: 1 },
    options: {
      queryOptions: {
        skip: !loggedIn,
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-and-network',
      },
    },
  })

  //we get the count from the order items count
  const count = document?.items?.length ?? 0

  //but if the status of the current order is not quotation, we set the count to 0
  // if (document?.status !== OrderStatusEnum.Quotation) count = 0

  return {
    count,
    refetch,
    _id: document?._id,
  }
}
